import { z } from "zod";

const baseIntervalFormSchema = z.object({
  minimumRange: z.coerce.number(),
  maximumRange: z.coerce.number().min(0).max(99999).step(1, "Field must be a whole number."),
  cost: z.coerce.number().min(0).max(999999999).step(0.01, "Field must be a maximum of 2 decimal places."),
});

const intervalsFormSchema = z.object({
  minimumRange: z.coerce.number().min(0).max(99999).step(1, "Field must be a whole number."),
  rate: z.coerce.number().min(0).max(999999999).step(0.01, "Field must be a maximum of 2 decimal places."),
});

export const stateRatesFormSchema = z.object({
  baseInterval: baseIntervalFormSchema,
  intervals: z.array(intervalsFormSchema),
});

export type StateRatesFormData = z.infer<typeof stateRatesFormSchema>;